import _PropTypes from 'prop-types';
import { useThemeContext } from '../../styles/themes/themes.js';
import { avatarSizeToPixelsMap } from '../AvatarUser/AvatarUser.js';
import { Circle } from '../Circle/Circle.js';
import { IconUserGroup } from '../Icons/IconUserGroup.js';
import { jsx } from 'react/jsx-runtime';

var AvatarTeam = function AvatarTeam(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size;

  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  var avatarLabel = i18n.AvatarTeam.avatarLabel;
  var iconSize = avatarSizeToPixelsMap[size].iconSize;
  return /*#__PURE__*/jsx(Circle, {
    size: size,
    "aria-label": avatarLabel,
    children: /*#__PURE__*/jsx(IconUserGroup, {
      role: "img",
      "aria-hidden": false,
      focusable: true,
      height: iconSize,
      width: iconSize
    })
  });
};

AvatarTeam.propTypes = {
  "size": _PropTypes.oneOf(["lg", "md", "sm", "xs"])
};
AvatarTeam.displayName = "AvatarTeam";

export { AvatarTeam };
